const STUDIO_QR_METADATA_FIELDS = [
    'owner_type',
    'created_by_source',
    'qr_style_version',
    'job_number',
    'provisioning'
];

export const sanitizeQrForClient = (qrData) => {
    if (!qrData || typeof qrData !== 'object' || Array.isArray(qrData)) return qrData;

    const sanitized = { ...qrData };
    STUDIO_QR_METADATA_FIELDS.forEach((field) => delete sanitized[field]);
    return sanitized;
};
